import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState, useMemo } from 'react';
import AMapLoader from '@amap/amap-jsapi-loader';
import '@amap/amap-jsapi-types';
const containerStyle = {
    width: '100%',
    height: '100%',
};
// Native supported dynamic props by Amap
// const NativeDynamicProps: Array<string> = [
//   'layers',
//   'zoom',
//   'center',
//   'labelzIndex',
//   // 'lang', native error in JSSDK when 3D viewMode
//   'mapStyle',
//   'features',
//   'cursor',
//   'pitch',
// ]
/*
 * Props below can set by 'setStatus' altogether
 */
// const StatusDynamicProps: Array<string> = [
//   'animateEnable',
//   'doubleClickZoom',
//   'dragEnable',
//   'isHotspot',
//   'jogEnable',
//   'keyboardEnable',
//   'resizeEnable',
//   'rotateEnable',
//   'scrollWheel',
//   'touchZoom',
//   'zoomEnable',
//   'touchZoomCenter',
// ]
// const StaticProps: Array<string> = [
//   'view',
//   'zooms',
//   'showIndoorMap',
//   'indoorMap',
//   'expandZoomRange',
//   'showBuildingBlock',
//   'viewMode',
//   'pitchEnable',
//   'buildingAnimation',
//   'skyColor',
// ]
// const CreateProps = NativeDynamicProps.concat(StatusDynamicProps, StaticProps)
const AMap = ({ MAP_ACCESS_TOKEN, style, mapStyle, plugins = [], onLoad, version = '2.0', mapOption = {}, }) => {
    const [map, setMap] = useState();
    const mapWrapper = useRef(null);
    const wrapperStyle = useMemo(() => {
        const _wrapperStyle = {
            width: '100%',
            height: '100%',
            position: 'relative',
        };
        return Object.assign(_wrapperStyle, style ? style : {});
    }, [style]);
    useEffect(() => {
        if (!mapWrapper.current)
            return;
        AMapLoader.load({
            key: MAP_ACCESS_TOKEN,
            version,
            plugins,
        }).then((AMap) => {
            const map = new AMap.Map(mapWrapper.current, mapOption);
            onLoad === null || onLoad === void 0 ? void 0 : onLoad(map);
            setMap(map);
        });
        return () => {
            setMap(undefined);
        };
    }, []);
    useEffect(() => {
        if (!map) {
            return;
        }
        map.setMapStyle(`amap://styles/${mapStyle}`);
    }, [map, mapStyle]);
    return (_jsx("div", { style: wrapperStyle, children: _jsx("div", { ref: mapWrapper, style: containerStyle }) }));
};
export default AMap;
